// extracted by css-extract-rspack-plugin
var _1 = "bXJC3";
export { _1 as "container" }
